// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2iriz","newExpiryDate":"styles_newExpiryDate__1FexB","footer":"styles_footer__1cIyZ"};